import { createReducer } from '../../reducers/factory';
import { MINUTE_MS, SECOND_MS } from '../../time';
import { UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION } from './consts';
import { getClosestCampaignStateTimestamp } from './utils';
import { fetchCampaigns } from '../../api/campaigns';
import { campaignsPlainSelector } from './selectors';

const name = 'campaigns';

const fetchReducer = createReducer('CAMPAIGNS', {
  fetchTimeout: 30 * SECOND_MS,
  invalidateActions: ['SET_LANGUAGE'],
  minUpdate: 30 * MINUTE_MS,
  initialState: {
    items: [],
    // This field stores the timestamp of the closest campaign start/end and is used to trigger the useSelector updates
    nextCampaignStateChangeTimestamp: null,
  },
  extendedReducer: {
    [UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION]: (state, action) => ({
      ...state,
      nextCampaignStateChangeTimestamp: action.timestamp,
    }),
    // This is overridden only to update the `nextCampaignStateChangeTimestamp` field if it was not set earlier
    // (the case when before the fetch there were no campaigns changing state in the future)
    FETCH_CAMPAIGNS_SUCCESSFUL: (state, action) => ({
      ...state,
      items: action.items,
      fetchingInProgressSince: null,
      lastSuccessfulFetch: action.timestamp,
      fetchPromise: null,
      didInvalidate: false,
      nextCampaignStateChangeTimestamp: getClosestCampaignStateTimestamp(
        action.items,
      ),
    }),
  },
});

export default { [name]: fetchReducer };

export const fetchCampaignsAction = () => async (dispatch, getState) => {
  const {
    auth: { apiUrl },
  } = getState();

  if (!apiUrl) {
    return {};
  }

  const fetchPromise = (async () => {
    try {
      dispatch(fetchReducer.fetchSuccessful(await fetchCampaigns(apiUrl)));
    } catch (e) {
      dispatch(fetchReducer.fetchFailed(e));
    }
  })();

  dispatch(fetchReducer.fetchInProgress(fetchPromise));
  return fetchPromise;
};

export const fetchCampaignsIfNeeded = () => async (dispatch, getState) => {
  const { fetchPromise, items, ...state } = campaignsPlainSelector(getState());

  if (fetchReducer.shouldFetch(state)) {
    return dispatch(fetchCampaignsAction());
  }

  return typeof fetchPromise?.then === 'function' ? fetchPromise : items;
};

export const setCampaignStateChangeTimestamp = (timestamp) => ({
  type: UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION,
  timestamp,
});
